import React, { useState } from 'react';
import { useToast } from '../contexts/ToastContext';
import apiClient from '../api/axiosConfig'; // Assuming you have an apiClient setup

function NewsletterSubscriptionForm() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [emailError, setEmailError] = useState(''); // New state for email validation error
  const { addToast } = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setEmailError(''); // Clear previous error on new submission

    // Basic client-side validation (optional, but good UX)
    if (!email) {
      setEmailError('Email address is required.');
      setLoading(false);
      return;
    }
    if (!/\S+@\S+\.\S+/.test(email)) {
      setEmailError('Email address is invalid.');
      setLoading(false);
      return;
    }

    try {
      const response = await apiClient.post('/subscribe-newsletter', { email });
      if (response.data.success) {
        addToast(response.data.message, 'success');
        setEmail('');
      } else {
        // Handle backend validation errors specifically
        if (response.response?.data?.errors?.email) { // Check for nested errors from Laravel validation
          setEmailError(response.response.data.errors.email[0]);
          addToast(response.response.data.errors.email[0], 'error');
        } else {
          const errorMessage = response.data.message || 'Failed to subscribe.';
          addToast(errorMessage, 'error');
        }
      }
    } catch (error) {
      if (error.response?.data?.errors?.email) { // Check for nested errors from Laravel validation
        setEmailError(error.response.data.errors.email[0]);
        addToast(error.response.data.errors.email[0], 'error');
      } else {
        const errorMessage = error.response?.data?.message || 'An error occurred during subscription.';
        addToast(errorMessage, 'error');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-gray-800 rounded-lg shadow-lg p-6 mb-8 border border-border-subtle">
      <h3 className="text-2xl font-bold text-text-white relative after:content-[''] after:absolute after:bottom-[-4px] after:left-0 after:w-16 after:h-1 after:bg-accent-red after:rounded-sm pb-1">
        Subscribe to our Newsletter
      </h3>
      <p className="text-text-gray text-sm mt-4 mb-4">
        Get the latest updates on new blog posts directly in your inbox.
      </p>
      <form onSubmit={handleSubmit} className="flex flex-col space-y-4">
        <div> {/* Wrapper div for input and error message */}
          <input
            type="email"
            placeholder="Your email address"
            className={`w-full p-3 rounded-md bg-bg-dark border ${emailError ? 'border-red-500' : 'border-border-subtle'} text-text-white focus:outline-none focus:ring-2 focus:ring-accent-red`}
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setEmailError(''); // Clear error on change
            }}
          />
          {emailError && <p className="text-red-500 text-sm mt-1">{emailError}</p>}
        </div>
        <button
          type="submit"
          className="bg-accent-red text-text-white rounded-md px-4 py-3 font-bold transition-all duration-300 hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed"
          disabled={loading}
        >
          {loading ? 'Subscribing...' : 'Subscribe'}
        </button>
      </form>
    </div>
  );
}

export default NewsletterSubscriptionForm;